import React from "react";

import { Trans, withTranslation } from "react-i18next";

import { Callout } from "@blueprintjs/core";
import { Tab, Tabs } from "@blueprintjs/core";

import Title from "../Structure/logo";
import CustomInterfaceEditor from "./CustomInterfaceEditor";
import OPnGOPage from "./OPnGOPage";
import BeMobilePage from "./BeMobilePage";
import PrestoParkPage from "./PrestoParkPage";
import GratuityParksPage from "./GratuityParksPage";


function ExternalAccessControlPage() {
  const [tabIndex, setTabIndex] = React.useState("opngo");
  const [config, setConfig] = React.useState({selected: [], remaining: []});

  React.useEffect(() => {
    const fetchData = async () => {
    }
    fetchData();
    return function () {
    }
  }, []);



  const handleTabChange = (selectedTab) => {
    setTabIndex(selectedTab);
  }
  const tabIsDisabled = (selectedTab) => {
    return !config.selected?.find(s => {return s.label === selectedTab});
  }
  const updateConfig = (config) => {
    setConfig(config);
    setTabIndex(config.selected[0].label);
  }

  const getTabIndex = () =>{
    if(localStorage.getItem('perm_admin') === "true"){
      return (
          <Tabs id="TabsExample" onChange={handleTabChange} selectedTabId={tabIndex}>
                <Tab id="opngo" disabled={tabIsDisabled("opngo")} title="OPnGO" panel={<OPnGOPage />} />
                <Tab id="bemobile" disabled={tabIsDisabled("bemobile")} title="BeMobile" panel={<BeMobilePage />} />
                <Tab id="prestopark" disabled={tabIsDisabled("prestopark")} title="PrestoPark" panel={<PrestoParkPage />} />
              <Tab id="gratuityparks" disabled={tabIsDisabled("gratuityparks")} title="GratuityParks" panel={<GratuityParksPage />} />
          </Tabs>);
    }
    else{
      return (
          <Tabs id="TabsExample" onChange={handleTabChange} selectedTabId={tabIndex}>
              <Tab id="gratuityparks" disabled={tabIsDisabled("gratuityparks")} title="GratuityParks" panel={<GratuityParksPage />} />
          </Tabs>);

    }
  }


  return (
    <div className="component-body">
      <Title text={<Trans>external access control</Trans>} />
      <Callout >
        <CustomInterfaceEditor update={updateConfig}></CustomInterfaceEditor>
      </Callout>

      <Callout >
      {config.selected.length > 0 ?
        getTabIndex()
        :
        <Callout intent="primary"><Trans>Please select one interface to active this feature</Trans></Callout>
      }
      </Callout>      
    </div>

  )
}

export default withTranslation()(ExternalAccessControlPage);